import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54fbeb6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "tips mt4" }
const _hoisted_8 = {
  key: 0,
  class: "footer xag-page__footer"
}
const _hoisted_9 = { class: "content" }
const _hoisted_10 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "logo" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "暂无地址信息", -1))

import AppHeader from '@/components/Header.vue'
import { getUserAddressList, removeAddress } from '@/apis/invoice'
import { computed, ref, Ref } from 'vue'
import { userAddressItem } from '@/types/invoice'
import { useRouter, Router } from 'vue-router'
import {
  addressListStorageKey,
  addressEditItemStorageKey,
  selectAddressStorageKey,
} from './definition'
import { setStorage } from '@/compositions/useMultiPlatformStorage'
import { Button, Tag, ActionSheet, Dialog } from 'vant'
import {
  showConfirmModal,
  showToastFail,
  showToastSuccess,
  showToastLoading,
  clearToast,
} from '@/utils/tools'
import router from '@/router'

interface invoiceInfoType {
  invoiceTypeColor: string
  invoiceTypeText: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'address-list',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const $router: Router = useRouter()
const components = {
  AppHeader,
}
const actionSheetShow: Ref<boolean> = ref(false)
const addressList: Ref<userAddressItem[]> = ref([])
const isLoading = ref(false)
let currentItem: userAddressItem
const hasAddressInfo = computed(() => {
  const list = addressList.value
  return list.length > 0
})
async function deleteAddress() {
  actionSheetShow.value = false
  try {
    await showConfirmModal({
      title: '删除收件地址？',
      message: '',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: '确定删除',
    })
    await removeAddress({ guid: currentItem.guid, type: 1 })
    showToastSuccess('删除成功')
    initAddress(true)
  } catch (error) {
    if (error) {
      let message = (error && error.message) || '删除失败'
      showToastFail(message)
    }
  }
}
function editInvoice() {
  actionSheetShow.value = false
  sessionStorage.setItem(addressEditItemStorageKey, JSON.stringify(currentItem))
  $router.push({
    name: 'invoice-address-edit',
    query: {
      guid: currentItem.guid,
    },
  })
}
const actionOptions = [
  { name: '编辑', callback: editInvoice },
  { name: '删除', color: '#FF4D4F', callback: deleteAddress },
]
function showAction(item: userAddressItem) {
  actionSheetShow.value = true
  currentItem = item
}
function addNewAddress() {
  $router.push({
    name: 'invoice-address-edit',
  })
}
async function initAddress(refresh = false) {
  isLoading.value = true
  showToastLoading()
  let storageStr = sessionStorage.getItem(addressListStorageKey)
  let data
  if (storageStr && !refresh) {
    data = JSON.parse(storageStr)
  } else {
    try {
      data = await getUserAddressList()
      sessionStorage.setItem(addressListStorageKey, JSON.stringify(data))
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  if (data) {
    addressList.value = data
  }
  clearToast()
  isLoading.value = false
}
function confirmSelect(item: userAddressItem) {
  // 确认选中
  setStorage(selectAddressStorageKey, item)
  router.go(-1)
}
initAddress()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "我的地址" }),
    (_unref(hasAddressInfo) || isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.guid,
                onClick: ($event: any) => (confirmSelect(item))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (item.default)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createVNode(_unref(Tag), { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode("默认")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(item.name) + " " + _toDisplayString(item.phone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.area_name) + " " + _toDisplayString(item.area_address), 1)
                ]),
                _createVNode(_component_van_icon, {
                  name: "ellipsis",
                  size: "16",
                  onClick: _withModifiers(($event: any) => (showAction(item)), ["stop"])
                }, null, 8, ["onClick"])
              ], 8, _hoisted_3))
            }), 128))
          ]),
          _createVNode(_unref(ActionSheet), {
            show: actionSheetShow.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((actionSheetShow).value = $event)),
            actions: actionOptions,
            "cancel-text": "取消",
            "close-on-click-action": ""
          }, null, 8, ["show"]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(Button), {
                    block: "",
                    class: "confirm-button",
                    onClick: addNewAddress
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增地址")
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", {
            class: "button",
            onClick: addNewAddress
          }, "新增地址")
        ]))
  ]))
}
}

})